<template>
  <div>
    <div class="flex flex-row px-4 justify-center mt-6">
      <div
        class="cursor-pointer transform hover:scale-110 duration-300 ease-in-out"
        @click="selectIndex(0)"
      >
        <div
          class="font-bebas text-peach uppercase text-2xl lg:text-4xl leading-none cursor-pointer "
                    :class="{ 'border-b-4 border-peach': selectedIndex === 0 }"
        >
          Day 1
        </div>
<!--        <div class="flex flex-row font-bebas uppercase items-top text-peach">-->
<!--          <div-->
<!--            class="text-6xl lg:text-massive leading-none"-->
<!--            :class="{ 'border-b-4 border-peach': selectedIndex === 0 }"-->
<!--          >-->
<!--            24-->
<!--          </div>-->
<!--          <div class="text-xl">th</div>-->
<!--        </div>-->
      </div>
      <div
        class="ml-4 pl-2  cursor-pointer transform hover:scale-110 duration-300 ease-in-out"
        @click="selectIndex(1)"
      >
        <div
          class="font-bebas text-darkpurple uppercase text-2xl lg:text-4xl leading-none"
          :class="{ 'border-b-4 border-darkpurple': selectedIndex === 1 }"
        >
          Day 2
        </div>
      </div>
      <div
        class="ml-4 pl-2  cursor-pointer transform hover:scale-110 duration-300 ease-in-out"
        @click="selectIndex(2)"
      >
        <div
          class="font-bebas text-green uppercase text-2xl lg:text-4xl leading-none"
          :class="{ 'border-b-4 border-green': selectedIndex === 2 }"
        >
          Day 3
        </div>
      </div>
      <div
        v-if="dates.length > 3"
        class="ml-4 pl-2  cursor-pointer transform hover:scale-110 duration-300 ease-in-out"
        :class="{ 'border-b-4 border-peach': selectedIndex === 3 }"
        @click="selectIndex(3)"
      >
        <div
          class="font-bebas text-peach uppercase text-2xl lg:text-4xl leading-none"
        >
          Day 4
        </div>
<!--        <div-->
<!--          class="flex flex-row font-bebas uppercase items-top text-peach cursor-pointer"-->
<!--        >-->
<!--          <div-->
<!--            class="text-6xl lg:text-massive leading-none"-->
<!--            :class="{ 'border-b-4 border-peach': selectedIndex === 3 }"-->
<!--          >-->
<!--            27-->
<!--          </div>-->
<!--          <div class="text-xl">th</div>-->
<!--        </div>-->
      </div>
    </div>
    <div
      v-for="session in groupedSessions[dates[selectedIndex]]"
      :key="session._id"
    >
      <session-schedule-block :session="session" />
    </div>
  </div>
</template>
<script>
import { sanityClient } from "../utils/sanity";
import SessionScheduleBlock from "../components/SessionScheduleBlock.vue";
import { auth, remindersCollection, db } from "../utils/firebase";
export default {
  components: {
    SessionScheduleBlock
  },
  data() {
    return {
      sessions: [],
      groupedSessions: null,
      dates: [],
      selectedIndex: 0,
      subscription: null,
      unsubscribeReminder: null,
      subscribedAll: false
    };
  },
  mounted() {
    // freeBundlesCollection
    //   .add({
    //     email: "test@vectric.com"
    //   })
    //   .then(docRef => {
    //     console.log("Document written with id: " + docRef.id);
    //   })
    //   .catch(error => console.error("Error adding document", error));
  },
  methods: {
    remindAll() {
      const batch = db.batch();
      this.sessions.map(session => {
        const reminder = {
          user: auth.currentUser.uid,
          emailAddress: auth.currentUser.email,
          sessionSlug: session.slug.current
        };
        let newReminderRef = remindersCollection.doc();
        batch.set(newReminderRef, reminder);
      });

      batch
        .commit()
        .then(() => {
          this.$store.dispatch(
            "setFlashMessage",
            "Thanks for subscribing. You'll be sent an email when sessions begin"
          );
        })
        .catch(err => {
          console.warn(err);
          this.$store.dispatch(
            "setFlashMessage",
            "An error occured and we couldn't set up reminders"
          );
        });
    },
    selectIndex(index) {
      this.selectedIndex = index;
    },
    subscribe() {
      // Sanity's listeners will listen to all changes to the returned docs
      // It does NOT listen to all changes to a query. Just an FYI
      const queryString =
        "*[_type == 'session' && !(_id in path('drafts.**'))]{_id}";
      return sanityClient
        .listen(queryString, {}, { includeResult: false, visibility: "query" })
        .subscribe(() => {
          this.fetchSessions();
        });
    },
    fetchSessions() {
      const queryString =
        "*[_type == 'session' && !(_id in path('drafts.**'))] | order(startTime asc) {productCompatibility[]->{...}, ...}";
      sanityClient
        .fetch(queryString)
        .then(res => {
          this.sessions = res;
          const sessionDates = [];
          const groups = res.reduce((groups, session) => {
            const date = new Date(session.startTime).toLocaleDateString();
            if (!groups[date]) {
              groups[date] = [];
              sessionDates.push(date);
            }
            groups[date].push(session);
            return groups;
          }, {});

          this.dates = sessionDates;
          this.groupedSessions = groups;
        })
        .catch(function(err) {
          console.log(err);
        });
    }
  },
  created() {
    this.fetchSessions();
    // this.subscription = this.subscribe();
    if (auth.currentUser) {
      this.unsubscribeReminder = remindersCollection
        .where("user", "==", auth.currentUser.uid)
        .onSnapshot(querySnapshot => {
          this.subscribedAll = querySnapshot.docs.length >= 18;
        });
    }
  },
  beforeDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.unsubscribeReminder) {
      this.unsubscribeReminder();
    }
  }
};
</script>
